import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2814ca26"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teachingcenter-warp w"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, [/*#__PURE__*/_createElementVNode("div", null, " 教案中心 "), /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202306/18241f51cafb49578abe552382972dd9.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div")], -1));

const _hoisted_3 = {
  class: "list-warp"
};
import CardHeader from '../../components/CardHeader.vue';
import ListItem from '../../teachingCenterList/components/ListItem/index.vue';
export default {
  props: {
    menu: {
      type: Object,
      default: () => ({})
    }
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    provide('menuInfo', ref(props.menu));
    const caseList = ref([]);

    const getHomeCaseList = async () => {
      const res = await $http.getCaseList({
        sort_type: 2
      });
      console.log('首页-教案', res);
      caseList.value = res.content;
    };

    getHomeCaseList();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caseList.value.slice(0, 4), item => {
        return _openBlock(), _createBlock(ListItem, {
          class: "item",
          key: item.id,
          caseData: item
        }, null, 8, ["caseData"]);
      }), 128))])]);
    };
  }

};